// src/constants/task.js

export const TASK_STATUS = {
  BACKLOG: 'backlog',
  IN_PROGRESS: 'in_progress',
  REVIEW: 'review',
  DONE: 'done',
};

export const TASK_STATUS_LABELS = {
  [TASK_STATUS.BACKLOG]: 'Backlog',
  [TASK_STATUS.IN_PROGRESS]: 'In Progress',
  [TASK_STATUS.REVIEW]: 'Review',
  [TASK_STATUS.DONE]: 'Done',
};

export const TASK_STATUS_ORDER = [
  TASK_STATUS.BACKLOG,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.REVIEW,
  TASK_STATUS.DONE,
];

export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

export const TASK_PRIORITY_LABELS = {
  [TASK_PRIORITY.LOW]: 'Low',
  [TASK_PRIORITY.MEDIUM]: 'Medium',
  [TASK_PRIORITY.HIGH]: 'High',
  [TASK_PRIORITY.CRITICAL]: 'Critical',
};

export const TASK_PRIORITY_ORDER = {
  [TASK_PRIORITY.CRITICAL]: 4,
  [TASK_PRIORITY.HIGH]: 3,
  [TASK_PRIORITY.MEDIUM]: 2,
  [TASK_PRIORITY.LOW]: 1,
};

export const STATUS_COLORS = {
  [TASK_STATUS.BACKLOG]: { bg: '#F1EFE8', text: '#5F5E5A', border: '#D3D1C7' },
  [TASK_STATUS.IN_PROGRESS]: { bg: '#E6F1FB', text: '#185FA5', border: '#B5D4F4' },
  [TASK_STATUS.REVIEW]: { bg: '#FAEEDA', text: '#854F0B', border: '#FAC775' },
  [TASK_STATUS.DONE]: { bg: '#EAF3DE', text: '#3B6D11', border: '#C0DD97' },
};

export const PRIORITY_COLORS = {
  [TASK_PRIORITY.LOW]: { bg: '#EAF3DE', text: '#3B6D11' },
  [TASK_PRIORITY.MEDIUM]: { bg: '#FAEEDA', text: '#854F0B' },
  [TASK_PRIORITY.HIGH]: { bg: '#FAECE7', text: '#993C1D' },
  [TASK_PRIORITY.CRITICAL]: { bg: '#FCEBEB', text: '#A32D2D' },
};

export const MOCK_ASSIGNEES = [
  'Alice Chen',
  'Bob Martinez',
  'Carol Johnson',
  'David Kim',
  'Emma Wilson',
  'Frank Lee',
];
